module.exports = __webpack_public_path__ + "static/media/Info.dabf8a28.svg";